<template>
  <div class="container-fluid">
    <div class="contents">
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-5"
          role="tabpanel"
          aria-labelledby="pills-5-tab"
        >
          <article class="article-header row g-0">
            <div class="col-12">
              <h5>{{ noticeinfo.noticetitle }}</h5>
            </div>
            <div class="d-flex flex-wrap">
              <div class="col-12 col-sm-6 text-black">
                <span
                  class="icon badge bg-purple"
                  :class="noticeinfo.category | get_custormer_category_bg"
                >
                  {{ noticeinfo.category | get_custormer_category }}
                </span>

                {{ $t("title.common.nickname2") }}{{ noticeinfo.writer }}
              </div>
              <div class="d-flex col-12 col-sm-6">
                <div class="ms-auto">
                  <span class="me-2">
                    <i class="material-icons">date_range </i>
                    {{ noticeinfo.regdate | dateformat }}
                  </span>
                  <span>
                    <i class="material-icons">visibility</i>
                    {{ noticeinfo.viewcnt | comma }}
                  </span>
                </div>
              </div>
            </div>
          </article>
          <article
            class="article-attach flex-column flex-sm-row"
            v-if="noticeinfo.as_filename"
          >
            <span class="d-inline-block me-1">{{
              $t("title.brandroom.attachment")
            }}</span>
            <a :href="noticeinfo.as_filepath | get_img" class="more">
              <span class="mt-2 mt-sm-0 text-break">
                <!-- <i class="material-icons-outlined">file_download</i> -->{{
                  noticeinfo.as_filename
                }}
              </span>
            </a>
          </article>

          <article class="article-body" v-if="noticeinfo.category === '1'">
            {{ $t("title.brandroom.noticedq") }}
            <span v-html="noticeinfo.content"></span>
          </article>
          <article class="article-body" v-else>
            {{ $t("title.brandroom.noticedq") }}
            <span v-html="noticeinfo.content"></span>
          </article>

          <div v-if="noticeinfo.status === '완료'">
            <article class="article-body">
              {{ $t("title.brandroom.costdq") }}{{ noticeinfo.answerprice }}
            </article>
            <article class="article-body">
              {{ $t("title.brandroom.answedq") }}{{ noticeinfo.answercontent }}
            </article>
            <article class="article-attach" v-if="noticeinfo.as_ans_filename">
              {{ $t("title.brandroom.attachmentdq")
              }}<a :href="noticeinfo.as_ans_filepath">
                <i class="material-icons-outlined">file_download </i>
                <span>{{ noticeinfo.as_ans_filename }}</span>
              </a>
            </article>
          </div>

          <article class="article-footer">
            <div class="prev" :class="!next_post.fit_as_pk && 'no-data'">
              <template v-if="next_post.fit_as_pk">
                <router-link
                  :to="{
                    name: 'CustomerView',
                    params: { noticeno: next_post.fit_as_pk },
                  }"
                >
                  <i class="material-icons"> expand_less </i>
                  <span>{{ next_post.title }}</span>
                </router-link>
              </template>
              <template v-else>
                <i class="material-icons"> expand_less </i>
                <span>{{ "이전 글이 없습니다." }}</span>
              </template>
            </div>
            <div class="next" :class="!prev_post.fit_as_pk && 'no-data'">
              <template v-if="prev_post.fit_as_pk">
                <router-link
                  :to="{
                    name: 'CustomerView',
                    params: { noticeno: prev_post.fit_as_pk },
                  }"
                >
                  <i class="material-icons"> expand_more </i>
                  <span>{{ prev_post.title }}</span>
                </router-link>
              </template>
              <template v-else>
                <i class="material-icons"> expand_less </i>
                <span>{{ "다음 글이 없습니다." }}</span>
              </template>
            </div>
          </article>

          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              aria-label="목록"
              @click="
                $router.push({
                  name: 'CustomerList',
                  query: { category: searchData.category },
                })
              "
              >{{ $t("button.brandroom.list") }}</b-button
            >
            <b-button
              v-if="noticeinfo.can_modify"
              size="xl"
              variant="secondary"
              aria-label="삭제"
              @click="noticeDelete"
              >{{ $t("button.common.delete") }}</b-button
            >
            <b-button
              v-if="noticeinfo.can_modify"
              size="xl"
              variant="primary"
              aria-label="수정"
              @click="modify"
              >{{ $t("button.common.edit") }}</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import ax from "@/api/fitting";
import "@/filter/common";

export default {
  name: "CustomerView",
  components: {
    location,
  },
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "fit_as_title",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        category: this.$route.query.category || 0,
      },
      noticeno: this.$route.params.noticeno || 0,
      noticeinfo: { content: "" },
      next_post: {},
      prev_post: {},
    };
  },
  methods: {
    modify() {
      if (this.noticeinfo.status == "완료") {
        alert(this.$i18n.t("alert.fitting.have_been_answered_cannot"));
      } else {
        this.$router.push({
          name: "CustomerWrite",
          params: { noticeno: this.$route.params.noticeno },
          query: { category: this.searchData.category },
        });
      }
    },
    get_custormerview() {
      ax.get_custormerview(this.noticeno, this.searchData, (flag, data) => {
        console.log(data);
        if (flag) {
          this.noticeinfo = data.noticeinfo;
          this.next_post = data.next_post;
          this.prev_post = data.prev_post;
        } else {
          alert(data.message);
        }
      });
    },
    noticeDelete() {
      ax.delete_custormerdelete(this.noticeno, (flag, data) => {
        if (flag) {
          alert(data.message);

          this.$router.push({
            name: "CustomerList",
          });
        } else {
          alert(data.message);
        }
      });
    },
  },
  created() {
    this.get_custormerview();
  },
  watch: {
    "$route.params": function () {
      this.noticeno = parseInt(this.$route.params.noticeno);
      this.get_custormerview();
    },
  },
};
</script>
